import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    testId: "faq-item-csr-compliance",
    q: "Does my NGO need CSR-1 registration before approaching corporates?",
    a: "Yes. Under Section 135 of the Companies Act, corporates can only fund NGOs registered with the MCA via Form CSR-1, along with valid 80G and 12A registrations. If you don't have these yet, our CSR Launchpad plan includes full compliance packaging — we prepare and file the documentation so you clear due diligence on the first pass.",
  },
  {
    testId: "faq-item-timelines",
    q: "How long does it take to receive the first corporate grant?",
    a: "For compliance-ready NGOs, the first grant typically closes within a few months. Larger consortium grants take longer because corporate budget cycles run quarterly or annually. Speed depends mainly on documentation readiness — which is exactly what our free eligibility audit assesses before we commit to a timeline.",
  },
  {
    testId: "faq-item-association-process",
    q: "How does the association process and fee model work?",
    a: "Every engagement starts with a free eligibility audit. Based on your NGO's size and goals, we propose one of three association frameworks — CSR Launchpad, Scale & Growth, or Institutional Enterprise. Fees are customized to your budget and aligned to fundraising milestones (dossier delivery, corporate shortlisting, grant closure), so you never pay for effort without outcomes.",
  },
  {
    testId: "faq-item-success-guarantee",
    q: "Do you guarantee that my NGO will receive CSR funding?",
    a: "No ethical fundraiser can guarantee a grant — the final decision always rests with the corporate CSR committee. What we do guarantee: boardroom-grade documentation, access to live CSR mandates matched to your sector, and professional representation. Our engagement success stays high because we only take on NGOs we assess as fundable during the free eligibility audit.",
  },
  {
    testId: "faq-item-which-corporates",
    q: "Which corporates and foundations do you work with?",
    a: "We maintain active relationships with CSR desks of IT majors, PSU energy companies, private banks, and manufacturing conglomerates, plus corporate foundations. We track live CSR budgets across education, healthcare, rural development, women empowerment, and climate sectors, and match your programs to the funder's stated mandate before any pitch.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-6">
        <div className="text-center">
          <p className="font-mono-alt mb-4 text-xs font-semibold tracking-[0.35em] text-[#E8862A]">07 / QUESTIONS</p>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#C7DAF5] bg-[#EAF1FC] px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-[#0E2A6B]">
            FAQ
          </span>
          <h2 className="mt-5 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
            Questions NGOs <span className="font-display italic text-[#0E2A6B]">ask us first</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="mt-10" data-testid="faq-accordion-section">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.testId} value={`item-${i}`} data-testid={f.testId} className="border-[#E6E9E6]">
              <AccordionTrigger className="text-left text-base font-semibold text-slate-900 hover:text-[#0E2A6B] hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm leading-relaxed text-slate-600">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
